import { render, staticRenderFns } from "./MiuTeacher.vue?vue&type=template&id=069476fe&scoped=true"
import script from "./MiuTeacher.vue?vue&type=script&lang=js"
export * from "./MiuTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069476fe",
  null
  
)

export default component.exports